import { render, staticRenderFns } from "./courseCartPrice.vue?vue&type=template&id=45267642&scoped=true&"
import script from "./courseCartPrice.vue?vue&type=script&lang=js&"
export * from "./courseCartPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45267642",
  null
  
)

export default component.exports